import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'student-round-view',
})

export default class StudentRoundViewComponent extends Vue {


    // -----------------------------------------------------
    // Properties

    @Prop({default: {}})
    private studentData!: any;

    @Prop()
    private isShowCaseView!: boolean;

    @Prop()
    private isStrugglingStudentView!: boolean;

    private get studentDatas() {
      return [
        {
          name: 'Knowledge',
          icon: 'emoji_objects',
          key: 'knowledge-data',
        },
        {
          name: 'Bio Graphical',
          icon: 'document_scanner',
          key: 'bio-data',
        },
        {
          name: 'Mindsets',
          icon: 'psychology',
          key: 'mindset',
        },
        {
          name: 'Context',
          icon: 'ability',
          key: 'context',
        },
        {
          name: 'Citizenship',
          icon: 'language',
          key: 'citizenship',
        },
      ];
    }
    private get studentInfo() {
      return {
        name: 'Profile',
        icon: 'student-profile',
        thumbnailUrl: this.studentData.avatorUrl,
      };
    }

    // old code
    // private get studentDetails() {
    //     return [
    //         {
    //             className: 'left-panel',
    //             cardDetails: [
    //                 {
    //                     name: 'Knowledge',
    //                     icon: 'knowlege',
    //                     thumbnailUrl: '/img/knowledge.svg',
    //                 },
    //                 {
    //                     name: 'Bio Graphical',
    //                     icon: 'bio-data',
    //                     thumbnailUrl: '/img/biograph.svg',
    //                 },
    //             ],
    //         },
    //         {
    //             className: 'center-panel',
    //             cardDetails: [
    //                 {
    //                     name: 'Mindsets',
    //                     icon: 'mindsets',
    //                     thumbnailUrl: '/img/mindset.svg',
    //                 },
    //                 {
    //                     name: 'Profile',
    //                     icon: 'student-profile',
    //                     thumbnailUrl: this.studentData.avatorUrl,
    //                 },
    //                 {
    //                     name: 'Context',
    //                     icon: 'context',
    //                     thumbnailUrl: '/img/context.svg',
    //                 },
    //             ],
    //         },
    //         {
    //             className: 'right-panel',
    //             cardDetails: [
    //                 {
    //                     name: 'Citizenship',
    //                     icon: 'citizenship',
    //                     thumbnailUrl: '/img/citizen.svg',
    //                 },
    //                 {
    //                     name: 'Behavior',
    //                     icon: 'behavior',
    //                     thumbnailUrl: '/img/behavior.svg',
    //                 },
    //             ],
    //         },
    //     ];
    // }


    // -----------------------------------------------------
    // Hooks


    // -----------------------------------------------------
    // Actions

    private onShowFacets() {
        let pathUrl = `/learners/${this.studentData.userId}?filter=true`;
        if (this.isShowCaseView) {
            pathUrl += '&isShowCaseView=true';
        }
        this.$router.push(pathUrl);
    }


    // -----------------------------------------------------
    // Methods


}
